import { sanitizeInternalPath } from "@/lib/navigation/authRedirect";

function withRedirectToQuery(
  basePath: string,
  redirectTo?: string | null,
): string {
  const safe = sanitizeInternalPath(redirectTo);
  if (safe === "/") {
    return basePath;
  }
  const sep = basePath.includes("?") ? "&" : "?";
  return `${basePath}${sep}redirectTo=${encodeURIComponent(safe)}`;
}

export function buildOnboardingNotificationsHref(
  redirectTo?: string | null,
): string {
  return withRedirectToQuery("/onboarding/notifications", redirectTo);
}

export function buildOnboardingDestinationHref(
  redirectTo?: string | null,
): string {
  return withRedirectToQuery("/onboarding/destination", redirectTo);
}
